export default {
    name: "features-answers",
    component: () => import(/* auth-router-module */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "feature",
            name: "features-index",
            meta: {
                breadcrumbs: [],
                title: "Características"
            },
            component: () => import('@/modules/features-answers/views/FeaturesIndex.vue')
        },
        {
            path: "answer",
            name: "answers-index",
            meta: {
                breadcrumbs: [],
                title: "Respuestas"
            },
            component: () => import('@/modules/features-answers/views/AnswersIndex.vue')
        }
    ]
}